import { useCallback, useState } from 'react';

const useFieldErrors = () => {
  const [errors, setErrors] = useState({});
  const clearError = useCallback(
    field => setErrors(prev => (prev[field] ? { ...prev, [field]: undefined } : prev)),
    []
  );
  return { errors, setErrors, clearError };
};

export function missingFieldErrors(formData, fields) {
  const errors = {};
  fields.forEach(field => {
    if (!formData.get(field)?.trim()) {
      errors[field] = `Please enter a ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`;
    }
  });
  return errors;
}

export default useFieldErrors;
